import {createAsyncThunk} from '@reduxjs/toolkit'

import {getFdsMerchantPenalty} from './apis'
import {MerchantPenaltyDetailResponse} from './interfaces'

/** FDS 통하여 가맹점의 FDS 검수상태 체크 */
export const getMerchantMerchantPenaltyStatus = createAsyncThunk<MerchantPenaltyDetailResponse, string[]>(
    'fdsInfo/getMerchantMerchantPenaltyStatus',
    async (merchantNos) => {
        const result = await getFdsMerchantPenalty(merchantNos)

        return result
    },
)
